import { ViewProperties } from "../../../utils/ViewProperties";
export class GameWinLineProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.distances = [146, 281, 416, 551, 689];
        this.expansion = 155;
        this.whiteThickness = 6;
        this.glowThickness = 18;
        this.colours = [0xEA0BFE, 0xEA0BFE, 0xEA0BFE, 0x27C8F6, 0xFFD909];
        this.glowBlur = 4;
        this.roundness = 0.2;
        this.emitterProperties = {
            emit: false,
            autoUpdate: true,
            frequency: 0.00075,
            maxParticles: 1000,
            pos: { x: 0, y: 0 },
            lifetime: { min: 0.6, max: 0.6 },
            behaviors: [
                {
                    type: "scale",
                    config: {
                        scale: {
                            list: [{ value: 0, time: 0 }, { value: 0.25, time: 0.05 }, { value: 0, time: 1 }],
                            isStepped: false
                        },
                        minMult: 0.1
                    }
                },
                {
                    type: "textureRandom",
                    config: {
                        textures: [
                            "Game-Particle"
                        ]
                    }
                },
                {
                    type: "rotationStatic",
                    config: {
                        min: 0,
                        max: 360,
                    }
                },
                {
                    type: "moveAcceleration",
                    config: {
                        accel: {
                            x: 0,
                            y: 0,
                        },
                        minStart: 0,
                        maxStart: 30,
                        rotate: true,
                    }
                },
            ],
        };
        this.emitterGlowDistance = 15;
        this.emitterGlowStrength = 5;
    }
}
//# sourceMappingURL=GameWinLineProperties.js.map